<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between pb-3>
      <h2>Import Print Template</h2>
      <v-spacer></v-spacer>
      <v-btn
          flat
          fab
          small
          type="button"
          class="ma-0"
          data-dismiss="modal"
          @click="$emit('close')"
          aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <v-layout row wrap pb-2>
      <v-autocomplete
        :label="$lang.actions.selectCompany"
        :items="mappedCompanies"
        v-model="selectedCompany"
        hide-details
      />
    </v-layout>
    <v-layout row wrap>
      <v-autocomplete
        :items="Object.keys(types)"
        :label="selectedCompany ? $lang.actions.selectPrintTemplateType : 'Select Company first'"
        :disabled="!selectedCompany || templatesForImport.length === 0"
        v-model="typeForImport"
        :hint="importHint"
        persistent-hint
        :loading="loading"
      />
    </v-layout>
    <v-layout row justify-end>
      <v-btn color="primary" :disabled="!typeForImport" class="mx-0" @click="submitTemplateImport()">
        Submit
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "PrintTemplatesImportModal",
    props: ['companies', 'types'],
    data() {
      return {
        err: '',
        loading: false,
        selectedCompany: null,
        templatesForImport: [],
        typeForImport: '',
        importHint: '',
      }
    },
    computed: {
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${ company.name } (${ company.companyStatus })`,
          value: company.id,
        }));
      },
    },
    watch: {
      selectedCompany(val) {
        if (val) {
          this.fetchTemplateForCompany(val);
        }
      },
      err(val) {
        if (val !== '') {
          setTimeout(() => {
            this.err = '';
          }, 5000);
        }
      },
    },
    methods: {
      fetchTemplateForCompany(id) {
        this.templatesForImport = [];
        this.loading = true;
        this.$http.post('printtemplate/fetchall', {companyId: id})
          .then((res) => {
            if (res.body.status === 'Success') {
                this.templatesForImport = res.body.details;
              this.loading = false;
              return;
            }
            this.err = res.body.statusText;
            this.loading = false;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
            this.loading = false;
          });
      },
      submitTemplateImport() {
        this.importHint = '';
        const findPrintTemplate = this.templatesForImport.find(x => x.type === this.typeForImport && x.status === 'active');
        if (findPrintTemplate) {
          this.$emit('submit', findPrintTemplate);
        } else {
          this.importHint = this.$lang.errors.noAvailableTemplate;
        }
      },
    },
    created() {

    }
  }
</script>

<style scoped>
  .pointerCursor {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// PrintTemplatesImportModal.vue?5dd327d3